






import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Vente} from '@/models';

import CrudVenteShow from '@/components/Crud/Vente/Show.vue';

@Component({
	components: {
	}
})
export default class CrudVenteAppointment extends Vue {
	@InOut({ type: Vente  , isVModel: true }) private value!: Vente;

	templateModel: {
		type: Object,
		default: () => { },
	}

}
